"use client";

import MediaImage from "@/components/ui/MediaImage";

import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import Link from "next/link";
import { Navigation } from "swiper/modules";
interface ImageSliderProps {
  images: { url: string; link: string; target?: "_blank" | "_self" }[];
}

const ImageSlider: React.FC<ImageSliderProps> = ({ images }) => {
  const sliderRef = useRef<any>(null);
  return (
    <div
      ref={sliderRef}
      className="relative h-full overflow-hidden custom-slider"
    >
      <Swiper modules={[Navigation]} speed={600} navigation={true}>
        {images
          .filter((x) => !!x)
          .map((image, index) => (
            <SwiperSlide className="relative" key={`imageslider-${index}`}>
              {image.link?.length > 0 ? (
                <Link
                  key={`section-${index}-link-${index}`}
                  target={image.target || "_blank"}
                  href={image.link}
                  className="relative w-full"
                  aria-label={`Billede`}
                >
                  <MediaImage
                    className="object-cover w-full"
                    src={image.url}
                    alt={`Image`}
                  />
                </Link>
              ) : (
                <MediaImage
                  key={`section-${index}-image-${index}`}
                  className="object-cover w-full"
                  src={image.url}
                  alt={`Image`}
                />
              )}
            </SwiperSlide>
          ))}
      </Swiper>
    </div>
  );
};

export default ImageSlider;
